import axios from "axios";
import React from "react";
import { API_BASE_URL } from "../config/constants";

const DeleteSuccessModal = ({
  username = "Admin XYZ",
  open,
  onClose,
  deleteUserData,
  onHandleChange
}) => {

  const handleDelete = async (id) => {
    try {

      await axios.delete(`${API_BASE_URL}/delete-user/${id}`);
    } catch (err) {
      alert("Delete failed: " + err.message);
    }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center px-4 bg-black/50 backdrop-blur-md
">
      <div className="w-[49.92rem] flex flex-col justify-center pt-[4.5rem] pr-[7.48rem] pb-[4.52rem] pl-[7.5rem] rounded-xl bg-[#051E1C]">

        {/* Text Section */}
        <div className="flex flex-col">
          <h2 className="text-white font-poppins text-[1.75rem] leading-[1.25rem] font-medium mb-[2.5625rem]">
            Delete User Forever?
          </h2>

          <p className="text-white font-poppins text-[1.125rem] font-normal">
            '{deleteUserData.email}' will be deleted forever. This can't be undone.
          </p>
        </div>

        {/* Actions: Side by Side on Right */}
        <div className="mt-8 flex justify-end gap-4">
          <button
            onClick={onClose}
            className="text-white w-[10.25rem] font-poppins h-[2.875rem] px-[1.0625rem] py-[0.6875rem] text-[1rem] font-bold not-italic"
          >
            Cancel
          </button>

          <button
            onClick={onHandleChange}
            className="w-[10.25rem] font-poppins h-[2.875rem] p-[0.6875rem_1.0625rem] bg-gradient-to-r from-[#DB5956] to-[#BA2723] text-white text-[1rem] font-bold not-italic leading-[1.75rem] capitalize rounded-[3.125rem]"
          >
            Delete Forever
          </button>
        </div>

      </div>
    </div>



  );
};

export default DeleteSuccessModal;
